import { TextField } from '@mui/material';
import React from 'react';
import { useController } from 'react-hook-form';
import { DateTimePicker, LocalizationProvider } from '@mui/lab';
import AdapterLuxon from '@mui/lab/AdapterLuxon';
import { DateTime } from 'luxon';
import get from 'lodash.get';

type Props = {
  name: string;
  required?: boolean;
  fullWidth?: boolean;
  label?: string;
  shrink?: boolean;
  timezone: string;
  onChange?: any;
  options?: any;
  maxDateTime?: any;
  minDateTime?: any;
};

const UDateTimePicker = (
  { name, required, fullWidth, label, shrink, timezone, onChange, options, minDateTime, maxDateTime }: Props,
  ref: any,
) => {
  const {
    field,
    formState: { errors },
  } = useController({ name, rules: options });
  const error = get(errors, name);
  const value = DateTime.fromMillis(parseFloat(field.value), { zone: timezone });
  if (minDateTime) minDateTime = DateTime.fromMillis(minDateTime, { zone: timezone });
  if (maxDateTime) maxDateTime = DateTime.fromMillis(maxDateTime, { zone: timezone });
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DateTimePicker
        renderInput={(props) => (
          <TextField
            {...props}
            required={required}
            fullWidth={fullWidth}
            InputLabelProps={{
              shrink: shrink === true,
            }}
            onBlur={field.onBlur}
            error={!!error}
            helperText={error ? error.message : null}
          />
        )}
        inputRef={(r) => {
          field.ref(r);
          if (ref) {
            if (typeof ref == 'function') ref(r);
            else ref.current = r;
          }
        }}
        maxDateTime={maxDateTime}
        minDateTime={minDateTime}
        label={label}
        value={value}
        onChange={(newValue: any) => {
          const t = newValue?.toMillis() || null;
          if (onChange) onChange(t);
          field.onChange(t);
        }}
      />
    </LocalizationProvider>
  );
};

export default React.forwardRef(UDateTimePicker);
